import React from "react";

function XIcon({
    color,
    width,
    height,
}: {
    color: string;
    width?: string;
    height?: string;
}) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width ?? "15"}
            height={height ?? "15"}
            fill="none"
            viewBox="0 0 15 15"
        >
            <path
                fill={color}
                d="M1.715 13.706l-1.004-1 5.523-5.5-5.523-5.5 1.004-1 5.524 5.5 5.523-5.5 1.004 1-5.523 5.5 5.523 5.5-1.004 1-5.523-5.5-5.524 5.5z"
            ></path>
            <path
                fill={color}
                fillRule="evenodd"
                d="M1.713 0l5.523 5.5L12.76 0l1.713 1.706-5.524 5.5 5.524 5.5-1.713 1.705-5.524-5.5-5.523 5.5L0 12.706l5.523-5.5L0 1.706 1.713 0zM12.76 1.411l-5.524 5.5-5.523-5.5-.296.295 5.524 5.5-5.524 5.5.296.294 5.523-5.5L12.76 13l.295-.294-5.523-5.5 5.523-5.5-.295-.295z"
                clipRule="evenodd"
            ></path>
        </svg>
    );
}

export default XIcon;
